// extracted by mini-css-extract-plugin
module.exports = {"modal_center":"PheDuyetModal_modal_center__kxM1S","tool_bar":"PheDuyetModal_tool_bar__2IP8W","text":"PheDuyetModal_text__6cury"};